document.addEventListener('DOMContentLoaded', function() {
  const accordionButtons = document.querySelectorAll('.faq-accordion-toggle-btn');
  
  accordionButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const parentItem = this.closest('.faq-accordion-item');
      const content = parentItem.querySelector('.faq-accordion-item-content');
      const isActive = parentItem.classList.contains('active');
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      // Close all other accordion items
      accordionButtons.forEach(otherButton => {
        const otherParentItem = otherButton.closest('.faq-accordion-item');
        const otherContent = otherParentItem.querySelector('.faq-accordion-item-content');
        
        if (otherParentItem !== parentItem) {
          otherParentItem.classList.remove('active');
          otherContent.style.display = 'none';
          otherButton.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Toggle current item
      if (isActive) {
        parentItem.classList.remove('active');
        content.style.display = 'none';
        this.setAttribute('aria-expanded', 'false');
      } else {
        parentItem.classList.add('active');
        content.style.display = 'block';
        this.setAttribute('aria-expanded', 'true');
      }
    });
    
    // Handle keyboard navigation
    button.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });
});